import { Grid } from '~/engine/data/common/Grid';
import {
    ResampleVolumeOptions,
    VolumeMapping,
    resampleVolumeInto,
} from '~/domain/services/resampleVolume';
import { validateDoseScale } from './doseFactor';

export interface MappedDose {
    readonly doseGy: Float32Array;
    readonly grid: Grid;
    // Voxels the transform does not reach: 0 Gy, and not a measured 0.
    readonly unmappedVoxels: number;
    // Voxels that land outside the source dose grid: 0 Gy, as no dose was planned there.
    readonly outsideSourceVoxels: number;
}

// Pulls each destination voxel center back through the mapping and samples the source dose (Gy).
export async function mapDoseGy(
    sourceGy: Float32Array,
    sourceGrid: Grid,
    destinationGrid: Grid,
    mapping: VolumeMapping,
    scale: number,
    options: Omit<ResampleVolumeOptions, 'backgroundValue'> = {}
): Promise<MappedDose | null> {
    validateDoseScale(scale);
    const doseGy = new Float32Array(
        destinationGrid.sizeX * destinationGrid.sizeY * destinationGrid.sizeZ
    );
    const coverage = await resampleVolumeInto(
        sourceGy,
        sourceGrid,
        doseGy,
        destinationGrid,
        mapping,
        { ...options, backgroundValue: 0 }
    );
    if (!coverage) {
        return null;
    }
    if (scale !== 1) {
        for (let i = 0; i < doseGy.length; i++) {
            doseGy[i] *= scale;
        }
    }
    return { doseGy, grid: destinationGrid, ...coverage };
}
